export default {
  ENTER: 13,
  SPACE: 32,
  UP: 38,
  DOWN: 40,
};
